export default __webpack_public_path__ + "static/media/02.1e7382a5.webp";